const accessAssignment = {
    ASSIGNMENT_LIST: { name: 'Assignment List', path: '/assignment-list' },
    ADD_ASSIGNMENT: { name: 'Add Assignment', path: '/add-assignment' },
    UPDATE_ASSIGNMENT: { name: 'Update Assignment', path: '/edit-assignment' },
    DELETE_ASSIGNMENT: { name: 'Delete Assignment', path: '/delete-assignment' },
};
export default accessAssignment;